// import { TronicPayloadMethod, TronicUserMetadata } from '@tronic-sdk/types';
// import { getItem, setItem, removeItem } from '../util/storage';
import { BaseModule } from './base-module';
// import { createJsonRpcRequestPayload } from '../core/json-rpc';
// import { createPromiEvent } from '../util';

// type UserLoggedOutCallback = (loggedOut: boolean) => void;

export class UserModule extends BaseModule {
  // public async getInfo() {
  //   const activeWallet = await getItem(this.localForageKey);
  //   const requestPayload = createJsonRpcRequestPayload(TronicPayloadMethod.GetInfo, [{ walletType: activeWallet }]);
  //   return this.request<TronicUserMetadata>(requestPayload);
  // }
  // public isLoggedIn = () => {
  //   return createPromiEvent<boolean, any>(async (resolve, reject) => {
  //     try {
  //       let cachedIsLoggedIn = false;
  //       if (this.sdk.useStorageCache) {
  //         cachedIsLoggedIn = (await getItem(this.localForageIsLoggedInKey)) === 'true';
  //         // if isLoggedIn is true on storage, optimistically resolve with true
  //         // if it is false, we use `usr.isLoggedIn` as the source of truth.
  //         if (cachedIsLoggedIn) {
  //           resolve(true);
  //         }
  //       }
  //       const requestPayload = createJsonRpcRequestPayload(
  //         this.sdk.testMode ? TronicPayloadMethod.IsLoggedInTestMode : TronicPayloadMethod.IsLoggedIn,
  //       );
  //       const isLoggedInResponse = await this.request<boolean>(requestPayload);
  //       if (this.sdk.useStorageCache) {
  //         if (isLoggedInResponse) {
  //           setItem(this.localForageIsLoggedInKey, true);
  //         } else {
  //           removeItem(this.localForageIsLoggedInKey);
  //         }
  //         if (cachedIsLoggedIn && !isLoggedInResponse) {
  //           this.emitUserLoggedOut(true);
  //         }
  //       }
  //       resolve(isLoggedInResponse);
  //     } catch (err) {
  //       reject(err);
  //     }
  //   });
  // };
  // public logout = () => {
  //   removeItem(this.localForageKey);
  //   removeItem(this.localForageIsLoggedInKey);
  //   return createPromiEvent<boolean, any>(async (resolve, reject) => {
  //     try {
  //       const requestPayload = createJsonRpcRequestPayload(
  //         this.sdk.testMode ? TronicPayloadMethod.LogoutTestMode : TronicPayloadMethod.Logout,
  //       );
  //       const response = await this.request<boolean>(requestPayload);
  //       if (this.sdk.useStorageCache) {
  //         this.emitUserLoggedOut(response);
  //       }
  //       resolve(response);
  //     } catch (err) {
  //       reject(err);
  //     }
  //   });
  // };
  // public onUserLoggedOut = (callback: UserLoggedOutCallback): void => {
  //   this.userLoggedOutCallbacks.push(callback);
  // };
  // // Private members
  // private emitUserLoggedOut = (loggedOut: boolean): void => {
  //   this.userLoggedOutCallbacks.forEach((callback) => {
  //     callback(loggedOut);
  //   });
  // };
  // private localForageKey = 'mc_active_wallet';
  // private localForageIsLoggedInKey = 'tronic_auth_is_logged_in';
  // private userLoggedOutCallbacks: UserLoggedOutCallback[] = [];
}
